import LockerType from 'src/models/locker/LockerType'
import DurationPeriod from 'src/models/period/DurationPeriod'
import Rental from 'src/models/rental/Rental'
import RentalBasedProduct from 'src/models/order/product/RentalBasedProduct'
import ReservationPickupRequestJson from 'src/models/order/interfaces/ReservationPickupRequestJson'

export default class ReservationPickupRequest extends RentalBasedProduct {
  static readonly PRODUCT_TYPE = 'reservation_pickup'

  readonly lockerType: LockerType
  readonly durationPeriod: DurationPeriod

  constructor(
    lockerType: LockerType,
    durationPeriod: DurationPeriod,
    rental: Rental | null,
  ) {
    super(ReservationPickupRequest.PRODUCT_TYPE, rental)
    this.lockerType = lockerType
    this.durationPeriod = durationPeriod
  }

  static fromJson(data: ReservationPickupRequestJson) {
    return new this(
      LockerType.fromJson(data.lockerType),
      DurationPeriod.fromJson(data.durationPeriod),
      data.rental ? Rental.fromJson(data.rental) : null,
    )
  }

  toJson(): ReservationPickupRequestJson {
    return {
      productType: this.productType,
      lockerType: this.lockerType.toJson(),
      durationPeriod: this.durationPeriod.toJson(),
      rental: this.rental ? this.rental.toJson() : null,
    }
  }
}
